/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Tab_Keyword_DescInputs */

const en_landing_tab_keyword_desc = /** @type {(inputs: Landing_Tab_Keyword_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI scans the job description, extracts critical keywords, and injects them naturally into your resume — improving your ATS keyword alignment.`)
};

const de_landing_tab_keyword_desc = /** @type {(inputs: Landing_Tab_Keyword_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`KI scannt die Stellenbeschreibung, extrahiert relevante Keywords und fügt sie natürlich in deinen Lebenslauf ein — für eine bessere ATS-Keyword-Übereinstimmung.`)
};

const fr_landing_tab_keyword_desc = /** @type {(inputs: Landing_Tab_Keyword_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI scans the job description, extracts critical keywords, and injects them naturally into your resume — improving your ATS keyword alignment.`)
};

const es_landing_tab_keyword_desc = /** @type {(inputs: Landing_Tab_Keyword_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI scans the job description, extracts critical keywords, and injects them naturally into your resume — improving your ATS keyword alignment.`)
};

const it_landing_tab_keyword_desc = /** @type {(inputs: Landing_Tab_Keyword_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI scans the job description, extracts critical keywords, and injects them naturally into your resume — improving your ATS keyword alignment.`)
};

const nl_landing_tab_keyword_desc = /** @type {(inputs: Landing_Tab_Keyword_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI scans the job description, extracts critical keywords, and injects them naturally into your resume — improving your ATS keyword alignment.`)
};

const pl_landing_tab_keyword_desc = /** @type {(inputs: Landing_Tab_Keyword_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI scans the job description, extracts critical keywords, and injects them naturally into your resume — improving your ATS keyword alignment.`)
};

const fi_landing_tab_keyword_desc = /** @type {(inputs: Landing_Tab_Keyword_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI scans the job description, extracts critical keywords, and injects them naturally into your resume — improving your ATS keyword alignment.`)
};

const da_landing_tab_keyword_desc = /** @type {(inputs: Landing_Tab_Keyword_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI scans the job description, extracts critical keywords, and injects them naturally into your resume — improving your ATS keyword alignment.`)
};

const sv_landing_tab_keyword_desc = /** @type {(inputs: Landing_Tab_Keyword_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI scans the job description, extracts critical keywords, and injects them naturally into your resume — improving your ATS keyword alignment.`)
};

/**
* | output |
* | --- |
* | "AI scans the job description, extracts critical keywords, and injects them naturally into your resume — improving your ATS keyword alignment." |
*
* @param {Landing_Tab_Keyword_DescInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const landing_tab_keyword_desc = /** @type {((inputs?: Landing_Tab_Keyword_DescInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Tab_Keyword_DescInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_landing_tab_keyword_desc(inputs)
	if (locale === "fr") return fr_landing_tab_keyword_desc(inputs)
	if (locale === "es") return es_landing_tab_keyword_desc(inputs)
	if (locale === "it") return it_landing_tab_keyword_desc(inputs)
	if (locale === "nl") return nl_landing_tab_keyword_desc(inputs)
	if (locale === "pl") return pl_landing_tab_keyword_desc(inputs)
	if (locale === "fi") return fi_landing_tab_keyword_desc(inputs)
	if (locale === "da") return da_landing_tab_keyword_desc(inputs)
	if (locale === "sv") return sv_landing_tab_keyword_desc(inputs)
	return en_landing_tab_keyword_desc(inputs)
});